import React, { useEffect, useState } from "react";
import FrontVideo from "../../components/homevideo";
import HeaderTitle from "../../components/headerTitle";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import PageLoader from "../../components/home/pageload";
import MetaTag from "../../components/CommonSections/MetaTag";
import ImgCloudPlatformManaged from "../../assest/images/IshanCloud Platform Managed.png";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";
import ColocationPopup from "../../components/colocation-popup";
import InternetServiceSec from "../../components/interner-service";
import { Modal, ModalBody } from "reactstrap";
import PlansTable from "./PlansTable";
import "../../styles/plans.css";
import CtaBanner from "../../components/CommonSections/CtaBanner";

export default function TestPage() {
  // ============================== HOOKS ==============================
  const [cloudPlans, setCloudPlans] = useState([]);
  const [storagePlans, setStoragePlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("general");

  const [InternetService, setInternetService] = useState(null);
  const [settingResponse, setSettingResponse] = useState(null);

  const [modal, setModal] = useState(false);
  const [colocationData, setcolocationData] = useState(null);

  const [getPlanModal, setPlanModal] = useState(false);
  const [planData, setPlanData] = useState(null);

  const [getInTuchPlanModal, setInTuchPlanModal] = useState(false);
  const [ctaData, setCtaData] = useState([]);

  // ============================== CATEGORY MAP ==============================
  const categories = {
    general: "General Category",
    compute: "Compute Optimized",
    memory: "Memory Optimized",
    storageOptimized: "Storage Optimized",
    cloudObject: "Cloud Object Storage",
  };

  // ============================== SCROLL HANDLER ==============================
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const offset = 110;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };

  // ============================== SCROLL EFFECT ==============================
  useEffect(() => {
    const sections = Object.keys(categories);

    const onScroll = () => {
      const scrollPosition = window.scrollY + 120;

      for (const category of sections) {
        const section = document.getElementById(category);
        if (!section) continue;

        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;

        if (scrollPosition >= top && scrollPosition < bottom) {
          setActiveCategory(category);
          break;
        }
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ============================== LOAD PLANS ==============================
  useEffect(() => {
    async function loadPlans() {
      try {
        const cloudRes = await axios.post(
          `${API_BASE_URL}/api/cloud-server-plans/plans/getPlans`
        );
        const storageRes = await axios.post(
          `${API_BASE_URL}/api/storage-services/plans/getPlans`
        );

        const ctaResponse = await axios.post(
          `${API_BASE_URL}/api/cloudeservices/getCloudeServices`,
          { service_tag: "cloud_plans" }
        );

        const ctaBannerData =
          ctaResponse?.data?.data?.cloude_services
            ?.cloude_services_cta_banner_data || [];

        setCtaData(ctaBannerData);

        setCloudPlans(cloudRes.data?.data?.plans || []);
        setStoragePlans(storageRes.data?.data?.plans || []);
      } catch (err) {
        console.error("Error loading plans or CTA data:", err);
      } finally {
        setLoading(false);
      }
    }
    loadPlans();
  }, []);

  // ============================== LOAD SMART CITY DATA ==============================
  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/smartcity/getsmartCity`, {
        service_tag: "cloud_plans",
      })
      .then((response) => {
        setInternetService(response);

        const generalSettingsData =
          response?.data?.data?.general_settings?.general_settings_data;

        const smartCitySetting = generalSettingsData?.find(
          (item) => item.tag === "smart_city_advantage"
        );

        const parsed = JSON.parse(smartCitySetting?.response || "{}");
        parsed.advantages = parsed;

        setSettingResponse(parsed);
      });
  }, []);

  // ============================== POPUP HANDLERS ==============================
  const toggle = () => setModal(!modal);

  const openModal = (data) => {
    setcolocationData(data);
    setModal(true);
  };

  const planToggle = () => setPlanModal(!getPlanModal);

  const openPlanModal = (data) => {
    setPlanData(data);
    setPlanModal(true);
  };

  const planGetIntuchToggle = () => setInTuchPlanModal(!getInTuchPlanModal);

  const openGetInTuchPlanModal = () => {
    setInTuchPlanModal(true);
  };

  // ============================== EARLY RETURNS ==============================
  if (loading) return <PageLoader />;
  if (!InternetService) return <PageLoader />;

  // ============================== GROUP PLANS ==============================
  const generalPurpose = cloudPlans.filter(
    (p) => p.category === categories.general
  );
  const computeOptimized = cloudPlans.filter(
    (p) => p.category === categories.compute
  );
  const memoryOptimized = cloudPlans.filter(
    (p) => p.category === categories.memory
  );
  const storageOptimized = cloudPlans.filter(
    (p) => p.category === categories.storageOptimized
  );

  const cloudObjectStorage = storagePlans.filter(
    (p) => p.category === categories.cloudObject
  );

  // ============================== RENDER ==============================
  return (
    <>
      <SubServiceSchema
        title={
          InternetService?.data?.data?.smart_city?.smart_city_banner_data[0]
            ?.title
        }
        url="https://ishantechnologies.com/systems-integration/smart-city-services"
        parentTitle="System Integration"
        parentUrl="https://ishantechnologies.com/systems-integration"
      />

      <MetaTag data={InternetService} pageKey="smart_city" />

      <div className="page_heading responsive_heading">
        <div className="container">
          <HeaderTitle headerTitledata={InternetService} pageKey="smart_city" />
        </div>
      </div>

      {/* ============================== BANNER ============================== */}
      <div className="video hero-banner internet-banner">
        <FrontVideo homeData={InternetService} pageKey="smart_city" />

        <div className="banner-content">
          <div className="content-blk">
            <h2 className="home-heading">
              {
                InternetService?.data?.data?.smart_city
                  ?.smart_city_banner_data[0].banner_title
              }
            </h2>

            <p className="para">
              {
                InternetService?.data?.data?.smart_city
                  ?.smart_city_banner_data[0].banner_img_desc
              }
            </p>

            <a
              href={
                InternetService?.data?.data?.smart_city
                  ?.smart_city_banner_data[0].button_url
              }
            >
              <button className="button hero-btn">
                {
                  InternetService?.data?.data?.smart_city
                    ?.smart_city_banner_data[0]?.button_img_name
                }
              </button>
            </a>
          </div>

          <div className="form-blk">
            <InternetServiceSec
              homeData={InternetService}
              pageName="InternetLeaseLine"
            />
          </div>
        </div>
      </div>

      {/* ============================== CLOUD PLATFORM INTRO ============================== */}
      <div className="empowering section-space spin-wrap pb-5">
        <div className="container">
          <div className="empowering-inner">
            <div className="empowering-left">
              <img
                src={ImgCloudPlatformManaged}
                alt="Ishan Cloud Platform"
                height="60"
                width="60"
                loading="lazy"
              />
            </div>

            <div className="empowering-right">
              <h2 className="text-primary">Ishan Cloud Platform</h2>
              <div className="f-18 mb-4">Scalable. Secure. Cost-Effective.</div>
              <div className="text-primary f-24">
                Choose the Right Plan for Your Business
              </div>
              <p className="para f-18 mb-0">
                At Ishan Technologies, we offer cloud solutions that fit your
                needs, whether you require high computing power, enhanced
                memory, or reliable storage.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ============================== PLANS WRAPPER ============================== */}
      <div className="plans-wrapper">
        {/* SIDEBAR */}
        <div className="sidebar">
          <h3>Cloud Server Plans +</h3>
          <ul>
            <li
              onClick={() => scrollToSection("general")}
              className={activeCategory === "general" ? "active" : ""}
            >
              General Purpose Cloud
            </li>

            <li
              onClick={() => scrollToSection("compute")}
              className={activeCategory === "compute" ? "active" : ""}
            >
              Compute-Optimised
            </li>

            <li
              onClick={() => scrollToSection("memory")}
              className={activeCategory === "memory" ? "active" : ""}
            >
              Memory-Optimised
            </li>

            <li
              onClick={() => scrollToSection("storageOptimized")}
              className={activeCategory === "storageOptimized" ? "active" : ""}
            >
              Storage-Optimised
            </li>
          </ul>

          <h3>Storage Services +</h3>
          <ul>
            <li
              onClick={() => scrollToSection("cloudObject")}
              className={activeCategory === "cloudObject" ? "active" : ""}
            >
              Cloud Object Storage
            </li>
          </ul>
        </div>

        {/* MAIN CONTENT */}
        <div className="tab-content-plan">
          <div id="general">
            <PlansTable
              title="General Purpose Cloud"
              plans={generalPurpose}
              type="cloud-server-plans"
            />
          </div>

          <div id="compute">
            <PlansTable
              title="Compute-Optimised Servers"
              plans={computeOptimized}
              type="cloud-server-plans"
            />
          </div>

          <div id="memory">
            <PlansTable
              title="Memory-Optimised Servers"
              plans={memoryOptimized}
              type="cloud-server-plans"
            />
          </div>

          <div id="storageOptimized">
            <PlansTable
              title="Storage-Optimised Servers"
              plans={storageOptimized}
              type="cloud-server-plans"
            />
          </div>

          <div id="cloudObject">
            <PlansTable
              title="Cloud Object Storage"
              plans={cloudObjectStorage}
              type="storage-services"
            />
          </div>

          <div className="footnotes">
            <p>* GST Extra as Applicable (18%)</p>
            <p>* Above Mentioned commercials are Monthly Basic Only</p>
            <p>* 1 Year Contract Period</p>
            <p>* Above Mentioned Commercials are Indicative</p>
            <p>* Private IP Plans</p>
          </div>
        </div>
      </div>

      <CtaBanner bannerData={ctaData} />

      {/* POPUPS */}
      <Modal isOpen={modal} toggle={toggle}>
        <ModalBody>
          <Link
            className="close1"
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
          >
            ×
          </Link>
          <ColocationPopup
            colocationData={colocationData}
            pageName="InternetLeaseLine"
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={getPlanModal} toggle={planToggle}>
        <ModalBody>
          <Link
            className="close1"
            onClick={(e) => {
              e.preventDefault();
              planToggle();
            }}
          >
            ×
          </Link>
          <ColocationPopup
            colocationData={colocationData}
            planDetails={planData}
            pageName="InternetLeaseLine"
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={getInTuchPlanModal} toggle={planGetIntuchToggle}>
        <ModalBody>
          <Link
            className="close1"
            onClick={(e) => {
              e.preventDefault();
              planGetIntuchToggle();
            }}
          >
            ×
          </Link>

          <div className="Mobile_getin_tuch">
            <InternetServiceSec
              homeData={InternetService}
              pageName="InternetLeaseLine"
            />
          </div>
        </ModalBody>
      </Modal>

      <a
        href="#"
        className="enquire-now-side-btn"
        onClick={() => openGetInTuchPlanModal()}
      >
        GET IN TOUCH
      </a>
    </>
  );
}
